module.exports = __webpack_public_path__ + "img/galway-swimming-pool-membership-450x300.8cf851ce.jpg";